import React from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useLoaderData} from 'react-router';

import {Header} from 'src/components';
import IconTabs from 'src/components/IconTabs';
import {DocumentationIcon, ExperimentIcon, PuzzleIcon, TechSupportIcon} from 'src/icons';
import PATHS from 'src/paths';

import * as S from './style';

export enum EIntegrationTabs {
  DOCUMENTATION = 'documentation',
  TESTING = 'testing',
  SETTINGS = 'settings',
  MODULES = 'modules',
}

const tabIconHash = {
  [EIntegrationTabs.DOCUMENTATION]: DocumentationIcon,
  [EIntegrationTabs.TESTING]: ExperimentIcon,
  [EIntegrationTabs.SETTINGS]: TechSupportIcon,
  [EIntegrationTabs.MODULES]: PuzzleIcon,
};

const Integration = React.memo(() => {
  const {t} = useTranslation();
  const {tabs} = useLoaderData<{tabs: EIntegrationTabs[]}>();

  const tabLabelHash = React.useMemo(
    () => ({
      [EIntegrationTabs.DOCUMENTATION]: t(`Integration:tabs.${EIntegrationTabs.DOCUMENTATION}`),
      [EIntegrationTabs.TESTING]: t(`Integration:tabs.${EIntegrationTabs.TESTING}`),
      [EIntegrationTabs.SETTINGS]: t(`Integration:tabs.${EIntegrationTabs.SETTINGS}`),
      [EIntegrationTabs.MODULES]: t(`Integration:tabs.${EIntegrationTabs.MODULES}`),
    }),
    [t],
  );

  return (
    <>
      <Header />
      <S.Section>
        <IconTabs
          tabs={tabs}
          tabIconHash={tabIconHash}
          tabLabelHash={tabLabelHash}
          path={PATHS.INTEGRATION_TAB}
        />
        <Outlet />
      </S.Section>
    </>
  );
});

Integration.displayName = 'Integration';

export default Integration;
